import React, { createContext, useEffect, useCallback } from 'react';
import useAuth from '../hooks/useAuth';
import { firestore } from './FirebaseContext';

const initialState = {
  etapa: 'atraccion'
};

export const MemberC = createContext({ ...initialState, changeEtapa: () => {} });

export default function MemberCProvider({ children }) {
  const [etapas, setEtapas] = React.useState(initialState);
  const { user } = useAuth();

  useEffect(() => {
    async function getEtapa() {
      await firestore
        .collection('ctaEtapas')
        .doc(user.id)
        .onSnapshot((doc) => {
          if (doc.exists) {
            const data = doc.data();
            setEtapas(data || initialState);
          } else {
            firestore.collection('ctaEtapas').doc(user.id).set({ etapa: initialState.etapa });
          }
        });
    }
    getEtapa();
  }, [user.id]);

  const changeEtapa = useCallback(
    (locationId) => {
      const etapa = etapas[locationId];
      const newEtapaObj = {};
      switch (etapa) {
        default:
        case 'atraccion':
          newEtapaObj[locationId] = 'interaccion';
          firestore.collection('ctaEtapas').doc(user.id).update(newEtapaObj);
          break;
        case 'interaccion':
          newEtapaObj[locationId] = 'deleite';
          firestore.collection('ctaEtapas').doc(user.id).update(newEtapaObj);
          break;
        case 'deleite':
          newEtapaObj[locationId] = 'atraccion';
          firestore.collection('ctaEtapas').doc(user.id).update(newEtapaObj);
          break;
      }
    },
    [etapas, user]
  );

  return <MemberC.Provider value={{ etapas, changeEtapa }}>{children}</MemberC.Provider>;
}
